import * as C from './components';

export const listOptions = (type, flagEasily, params = {}) => {
	if (flagEasily === null) {
		flagEasily = 1;
	}
	switch (type) {
		case 'exact-answer':
			if(params.forProbe) {
				const resultExactAnswer = [
					C.CorrectAnswerMulti,
					C.Key,
				];
				if (params.weightVisible) {
					resultExactAnswer.push(C.Weight);
				}
				return resultExactAnswer;
			}
			const resultExactAnswer = [
				C.Question,
				C.Images,
				C.Audios,
				C.CorrectAnswerMulti,
				C.NumberOfAttempts,
				C.Hint,
				C.Video,
			];
			
			if (flagEasily === 0) {
				resultExactAnswer.push(
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
					C.IgnoreSpacesAndCase,
					C.DisplayHintAfterAllAttempts,
					C.IsNumberAnswer
				);
			} 
			else {
				if (params.themeVisible) {
					resultExactAnswer.push(C.Theme);
				}
				if (params.subThemeVisible) {
					resultExactAnswer.push(C.Subtheme);
				}
				if (params.weightVisible) {
					resultExactAnswer.push(C.Weight);
				}
				resultExactAnswer.push(
					C.Key,
					C.IsTimedTask,
					C.IgnoreSpacesAndCase,
					C.DisplayHintAfterAllAttempts,
					C.IsNumberAnswer);
			}
			return resultExactAnswer;

		case 'order':
			if(params.forProbe) {
				const resultOrder = [
					C.Sequence,
					C.SequenceType,
					C.Key,
				];
				if (params.weightVisible) {
					resultOrder.push(C.Weight);
				}
				return resultOrder;
			}
			const resultOrder = [
				C.Question,
				C.Images,
				C.Audios,
				C.Sequence,
				C.SequenceType,
				C.NumberOfAttempts,
				C.Hint,
				C.Video,
			];
			if (flagEasily === 0) {
				resultOrder.push(
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			} 
			else {
				if (params.themeVisible) {
					resultOrder.push(C.Theme);
				}
				if (params.subThemeVisible) {
					resultOrder.push(C.Subtheme);
				}
				if (params.weightVisible) {
					resultOrder.push(C.Weight);
				}
				resultOrder.push(
					C.Key,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			}
			return resultOrder;
			
		case 'multiple-choice':
			if(params.forProbe) {
				const resultMultipleChoice = [
					C.Sequence,
					C.OrderImportant,
					C.Key,
				];
				if (params.weightVisible) {
					resultMultipleChoice.push(C.Weight);
				}
				return resultMultipleChoice;
			}
			const resultMultipleChoice = [
				C.Question,
				C.Images,
				C.Audios,
				C.Sequence,
				C.OrderImportant,
				C.NumberOfAttempts,
				C.Hint,
				C.Video,
			];
			if (flagEasily === 0) {
				resultMultipleChoice.push(
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			} 
			else {
				if (params.themeVisible) {
					resultMultipleChoice.push(C.Theme);
				}
				if (params.subThemeVisible) {
					resultMultipleChoice.push(C.Subtheme);
				}
				if (params.weightVisible) {
					resultMultipleChoice.push(C.Weight);
				}
				resultMultipleChoice.push(
					C.Key,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			}
			return resultMultipleChoice;

		case 'test':
			const resultTest = [
				C.Question,
				C.Images,
				C.Audios,
				C.OptionsAnswer,
				C.CorrectAnswer,
				C.NumberOfAttempts,
				C.Hint,
				C.Video,
			];
			if (flagEasily === 0) {
				resultTest.push(
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			} 
			else {
				if (params.themeVisible) {
					resultTest.push(C.Theme);
				}
				if (params.subThemeVisible) {
					resultTest.push(C.Subtheme);
				}
				if (params.weightVisible) {
					resultTest.push(C.Weight);
				}
				resultTest.push(
					C.Key,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			}
			return resultTest;
			
		case 'basket':
			const resultBasket = [
				C.Question,
				C.Images,
				C.Audios,
				C.Basket,
				C.NumberOfAttempts,
				C.Hint,
				C.Video,
			];
			if (flagEasily === 0) {
				resultBasket.push(
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			} 
			else {
				if (params.themeVisible) {
					resultBasket.push(C.Theme);
				}
				if (params.subThemeVisible) {
					resultBasket.push(C.Subtheme);
				}
				if (params.weightVisible) {
					resultBasket.push(C.Weight);
				}
				resultBasket.push(
					C.Key,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			}
			return resultBasket;
		case 'drawing-image': 
			const drawingImage = [
				C.Question,
				C.Images,
				C.ImagesDrawing,
				C.Audios,
				C.Hint,
				C.Video,
			];
			if (flagEasily === 0) {
				drawingImage.push(
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
				);
			} 
			else {
				if (params.themeVisible) {
					drawingImage.push(C.Theme);
				}
				if (params.subThemeVisible) {
					drawingImage.push(C.Subtheme);
				}
				if (params.weightVisible) {
					drawingImage.push(C.Weight);
				}
				drawingImage.push(
					C.Key,
					C.IsTimedTask,
				);
			}
			return drawingImage;

		case 'pass-words':
			const resultPassWords = [
				C.Question,
				C.Omissions,
				C.Images,
				C.Audios,
				C.NumberOfAttempts,
				C.Hint,
				C.Video,
			];
			if (flagEasily === 0) {
				resultPassWords.push(
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
					C.IgnoreSpacesAndCase,
					C.DisplayHintAfterAllAttempts
				);
			} 
			else {
				if (params.themeVisible) {
					resultPassWords.push(C.Theme);
				}
				if (params.subThemeVisible) {
					resultPassWords.push(C.Subtheme);
				}
				if (params.weightVisible) {
					resultPassWords.push(C.Weight);
				}
				resultPassWords.push(
					C.Key,
					C.IsTimedTask,
					C.IgnoreSpacesAndCase,
					C.DisplayHintAfterAllAttempts
				);
			}
			return resultPassWords;

		case 'match':
			const resultMatch = [
				C.Question,
				C.Images,
				C.Audios,
				C.MatchList,
				C.NumberOfAttempts,
				C.Hint,
				C.Video,
			];
			if (flagEasily === 0) {
				resultMatch.push(
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			} 
			else {
				if (params.themeVisible) {
					resultMatch.push(C.Theme);
				}
				if (params.subThemeVisible) {
					resultMatch.push(C.Subtheme);
				}
				if (params.weightVisible) {
					resultMatch.push(C.Weight);
				}
				resultMatch.push(
					C.Key,
					C.IsTimedTask,
					C.DisplayHintAfterAllAttempts
				);
			}
			return resultMatch;

		case 'probe-c':
			if (flagEasily === 0) {
				return [
					C.Question,
					C.Images,
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Key,
					C.Weight,
				];
			} else {
				return [
					C.Question,
					C.Images,
					C.Key
				];
			}
		case 'detail-answer':
			if (flagEasily === 0) {
				return [
					C.Question,
					C.Images,
					C.Audios,
					C.Hint,
					C.Video,
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.CantUploadFiles,
					C.IsTimedTask,
				];
			} 
			else {
				const resultDetailAnswer = [
					C.Question,
					C.Images,
					C.Audios,
					C.Hint,
					C.Video
				]
				if (params.themeVisible) {
					resultDetailAnswer.push(C.Theme);
				}
				if (params.subThemeVisible) {
					resultDetailAnswer.push(C.Subtheme);
				}
				if (params.weightVisible) {
					resultDetailAnswer.push(C.Weight);
				}
				resultDetailAnswer.push(
					C.Key, 
					C.CantUploadFiles, 
					C.IsTimedTask
				);
				
				return resultDetailAnswer;
			}
		default:
			if(params.forProbe) {
				const resultOrder = [
					C.Question,
					C.Key,
					C.Images,
					C.Audios,
				];
				if (params.weightVisible) {
					resultOrder.push(C.Weight);
				}
				return resultOrder;
			}
			if (flagEasily === 0) {
				return [
					C.Question,
					C.Images,
					C.Audios,
					C.Hint,
					C.Video,
					C.ExamNumber,
					C.Theme,
					C.Subtheme,
					C.Complexity,
					C.Key,
					C.Weight,
					C.IsTimedTask,
				];
			} else {
				return [
					C.Question, 
					C.Images, 
					C.Audios, 
					C.Hint, 
					C.Video, 
					C.Key, 
					C.IsTimedTask,
				];
			}
	}
};